import DataStore from '../DataStore';
import { makeEl } from '../../common/Utils';
import { ILinkList } from '../../interface/IFooter';
import Layer from '../Layer';

export default class Links {
  private ds: DataStore;
  private btn!: HTMLButtonElement;
  private gradeLayer!: HTMLSpanElement;

  constructor(_wrapper: HTMLElement) {
    this.ds = DataStore.instance;
    if (this.ds.config.linkList.length > 0) {
      this.templ(_wrapper);
      this.addEvents();
    }
  }

  templ(_parent: HTMLElement) {
    const tmpl = makeEl('nav', _parent, { class: 'footer-links' });
    const ul = makeEl('ul', tmpl, { class: 'footer-links-list' });
    this.ds.config.linkList.map((it) => {
      if (it.name === 'doNotSell') {
        if (this.ds.geoCountry === 'US') {
          this.liTempl(ul, it);
        }
      } else {
        this.liTempl(ul, it);
      }
    });
  }

  liTempl(_parent: HTMLUListElement, _data: ILinkList) {
    const li = makeEl('li', _parent, { class: 'footer-links-item' });
    const isBold = _data.isBold ? _data.isBold : false;
    const text = this.ds.l10n.linkList[_data.name];

    if (_data.type === 'link') {
      const link = makeEl('a', li, {
        href: this.makeLink(_data.name, _data.link),
        target: _data.target,
      });
      this.textTempl(link, isBold, text);
    } else if (_data.type === 'image' && this.ds.config.gameGrade) {
      li.classList.add('grade-layer-item');
      this.btn = makeEl(
        'button',
        li,
        { class: 'btn-grade-layer', href: _data.link, target: _data.target },
        text
      );
      this.gradeLayer = makeEl('span', this.btn, {
        class: 'grade-layer',
        id: 'FooterGradeLayer',
      });
      makeEl('img', this.gradeLayer, { src: this.ds.config.gameGrade });
    }
  }

  makeLink(_linkName: string, _link: string): string {
    let resultLink: string = _link;
    if (_linkName === 'operationPolicy' && this.ds.config.operationPolicyLink) {
      resultLink = this.ds.config.operationPolicyLink;
    } else if (
      _linkName === 'communityPolicy' &&
      this.ds.config.communityPolicyLink
    ) {
      resultLink = this.ds.config.communityPolicyLink;
    } else if (
      _linkName === 'cookiePolicy' &&
      this.ds.config.cookiePolicyLink
    ) {
      resultLink = this.ds.config.cookiePolicyLink;
    } else if (
      _linkName === 'legalDocumentation' &&
      this.ds.config.legalDocumentationLink
    ) {
      resultLink = this.ds.config.legalDocumentationLink;
    } else if (_linkName === 'termsOfUse' && this.ds.config.termsOfUseLink) {
      resultLink = this.ds.config.termsOfUseLink;
    } else if (_linkName === 'gameGrade' && this.ds.config.gameGradeLink) {
      resultLink = this.ds.config.gameGradeLink;
    }
    return resultLink;
  }

  textTempl(_parent: HTMLAnchorElement, _isBold: boolean, _text: string) {
    const tagName = _isBold ? 'strong' : 'span';
    makeEl(tagName, _parent, undefined, _text);
  }

  addEvents() {
    if (this.gradeLayer) {
      this.btn.addEventListener('click', (e) => {
        Layer.toggleLayer(this.gradeLayer.id);
        e.stopPropagation();
      });
    }
  }
}
